import { render, staticRenderFns } from "./LanguageDropdownMenu.vue?vue&type=template&id=b26054bc&"
import script from "./LanguageDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./LanguageDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./LanguageDropdownMenu.vue?vue&type=style&index=0&id=b26054bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports